export const socialsData = {
    github: 'https://github.com/ProgrammingPirates',
    linkedIn: 'https://www.linkedin.com/in/dharmendra-solanki-a72127206/',
    twitter: 'https://twitter.com/Dharmen84416248',
    blogger: 'https://www.investopedia.study/',
    youtube: 'https://www.youtube.com/channel/UCYhSBDj1pcUqhHlmUOlokvA'
}